/**
 * Admin Guard Signal Bus
 * Manages admin shell state signaling
 */

export type AdminGuardShell = 'public' | 'authenticated';

let currentShell: AdminGuardShell = 'public';

function updateWindowShell(shell: AdminGuardShell) {
  if (typeof window === 'undefined') return;
  (window as any).__LIQUID_ADMIN_GUARD_SHELL__ = shell;
}

export function setAdminGuardShell(shell: AdminGuardShell): void {
  currentShell = shell;
  updateWindowShell(shell);
}

export function getAdminGuardShell(): AdminGuardShell {
  if (typeof window !== 'undefined') {
    const globalShell = (window as any).__LIQUID_ADMIN_GUARD_SHELL__;
    if (globalShell === 'public' || globalShell === 'authenticated') {
      currentShell = globalShell;
    }
  }
  return currentShell;
}

// Initialize with public shell to ensure deterministic default
setAdminGuardShell('public');